export const secondTicksToDateTime = (ticks) => {
  //ticks are in nanotime; convert to microtime
  var ticksToMicrotime = ticks / 10000;

  //ticks are recorded from 1/1/1; get microtime difference from 1/1/1/ to 1/1/1970
  var epochMicrotimeDiff = Math.abs(new Date(0, 0, 1).setFullYear(1));

  return new Date(ticksToMicrotime - epochMicrotimeDiff);
}
